import React from 'react';
import { Table as AntTable, Space, Avatar, Popconfirm,Input ,Button } from 'antd';
import { useState,useRef } from "react";
import { UserOutlined,SearchOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../function/genNumberTable';
import { useStateContext } from '../../../../contexts/ContextProvider';
import { SHIFT_MAPPING, JOB_TYPE_MAPPING } from '../../../../data/constant';

const headerStyle = {
  color: '#525252',
};

const Table = ({ data, onEdit, onDelete, loading }) => {
  const { currentColor } = useStateContext();
  const [ setSearchText] = useState('');
  const [ setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    { 
      title: 'วันที่',
      align: 'center',  
      width: 60, 
      dataIndex: 'date',
      key: 'number',
      onHeaderCell: () =>{return {style:headerStyle}}
    },
    { 
      title: 'UserName', 
      align: 'center', 
      dataIndex: 'UserName', 
      key: 'UserName',
      onHeaderCell: () =>{return {style:headerStyle}} ,
    },
    { 
      title: 'เข้างาน', 
      align: 'center', 
      dataIndex: 'checkIn', 
      key: 'checkIn',
      onHeaderCell: () =>{return {style:headerStyle}} ,
    },
    { 
      title: 'ออกงาน', 
      align: 'center', 
      dataIndex: 'checkOut', 
      key: 'checkOut',
      onHeaderCell: () =>{return {style:headerStyle}},
    },
    { 
      title: 'กะงาน', 
      align: 'center', 
      dataIndex: 'shift', 
      key: 'shift',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      render: (shift) => SHIFT_MAPPING[shift] || '-'
    },
    {
      title: 'หน้าที่งาน', 
      align: 'center', 
      dataIndex: 'jobType', 
      key: 'jobType',
      onHeaderCell: () =>{return {style:headerStyle}} ,
    },
    {
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      render: (record) => (
        <Space size="middle">
          <div className="text-blue-500 cursor-pointer" onClick={() => onEdit(record)}>
            แก้ไข
          </div>
          {/* <Popconfirm
            title="ลบข้อมูล"
            description="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onDelete(record)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
            okButtonProps={{ style: { backgroundColor: currentColor, borderColor: currentColor } }}
          >
            <div className="text-red-500 cursor-pointer">ลบ</div>
          </Popconfirm> */}
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    }
  ];

  return ( 
    <div className='overflow-x-auto'>
      <AntTable 
        loading={loading}   
        className='border-1 rounded-lg border-gray-200' 
        dataSource={genNumberTable(data)}
        columns={columns}  
        pagination={{ pageSize: 8 }} 
        rowKey={'id'}
        scroll={{ x: 'max-content' }}  
      />
    </div>
  );
};

export default Table;
